export const actionTypes = {
    GET_RECIPE: 'recipe/getRecipe',
    GET_FILTERED_RECIPE: 'recipe/getFilteredRecipe',
    GET_INGREDIENTS_LIST: 'recipe/getIngredients',
    GET_RESTRICTIONS_LIST: 'recipe/getRestrictions',
    LOGIN: 'user/login',
    ADD_FAVOURITE_RECIPE: 'user/addFavouriteRecipe',
    DELETE_FAVOURITE_RECIPE: 'user/deleteFavouriteRecipe',
    GET_FAVOURITE_RECIPES: 'user/getFavouriteRecipes',
    DISPLAY_RECIPE: 'recipe/displayRecipe'
}
